module.exports = __webpack_public_path__ + "static/media/jsImg7.4fe03113.png";